import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postOutboundDataResync = createApi("OutboundDataResyncPostAPI","POST");

const OutboundDataResyncPostAPI = createSlice({
  name: 'OutboundDataResyncPostAPI',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postOutboundDataResync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postOutboundDataResync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postOutboundDataResync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default OutboundDataResyncPostAPI.reducer;